import { CLEAR_STATUS } from 'store/ui/types'
import * as types from './types'

const initialState = {
  list: null,
  error: null,
  meta: null,
  msg: null,
  loading: false,
}

export default function emergencies(state = initialState, { type, payload }) {
  switch (type) {
    case types.GET_EMERGENCIES_REQUEST:
      return { ...state, loading: true }
    case types.GET_EMERGENCIES_SUCCESS:
      return {
        ...state,
        list: payload.emergencies,
        meta: payload.meta,
        loading: false,
      }
    case types.GET_EMERGENCIES_ERROR:
      return { ...state, loading: false }
    case types.CREATE_EMERGENCY_SUCCESS:
      return { ...state, msg: payload.msg }
    case types.CREATE_EMERGENCY_ERROR:
      return { ...state, error: payload.error }
    case CLEAR_STATUS:
      return { ...state, error: null, msg: null }
    default:
      return state
  }
}
